import styled, { css } from 'styled-components';

import { Box } from '@mui/material';

export const Wrapper = styled(Box)`
  ${({ theme }) => css`
    .chart-tooltip {
      display: none;
      background-color: #231b22 !important;
      color: ${theme.yoga.colors.white} !important;
      padding: ${theme.spacing(1)} !important;
    }
  `}
`;
